/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     Login
//   Details:    Login page
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 101871 13/06/19 JHT M01  Added 'first time user'
// 106452 04/03/20 JC  M02  Ensure a compatible browser is used
// 106380 30/04/20 JC  M03  Added SSO
//-------------------------------------------------------
*/

import React, { Component } from 'react';
import { Button, FormGroup, FormControl, FormLabel, Col } from "react-bootstrap";
import { bindActionCreators } from 'redux';
import { history } from '../history';
import { connect } from 'react-redux';
import { userActions } from '../store/Authentication';
import Loading from '../components/Loading';
import AlertPanel from '../components/AlertPanel';
import { utils } from '../utils/utils'; //M02

class Login extends Component {
	constructor(props) {
		super(props);

		this.state = {
			employeeCode: '',
			password: '',
            accessCode: '',
            browserError: !utils.detectCompatibleBrowser() //M02 detect compatible browser
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleLogin = this.handleLogin.bind(this);
        this.handleForgotPassword = this.handleForgotPassword.bind(this);
	}

    // M03 This method runs when the component is first added to the page
    componentDidMount() {

        //pulls compnents off the route path paramers...
        const { ssoAuthenticationTicket } = this.props.match.params;

        //if exists
        if (ssoAuthenticationTicket) {

            //auto login with SSO login method
            this.props.ssoLogin(ssoAuthenticationTicket);
        }
    }

	validateForm() {
		return this.state.employeeCode.length > 0
			&& this.state.password.length > 0;
	}

	handleChange = event => {
		this.setState({
			[event.target.id]: event.target.value
		});
	}

	handleLogin = event => {
        event.preventDefault();
        //M02 not if there's a browser error
        if (!this.state.browserError) {
            this.props.login(this.state.employeeCode, this.state.password);
        }
	}

	handleForgotPassword = event => {
        event.preventDefault();
        //M02 not if there's a browser error
        if (!this.state.browserError) {
            history.push('/forgotpassword');
        }
	}

	render() {
        const { authentication } = this.props;
        const { browserError } = this.state; //M02
		return (
			<Col sm={{ span: 6, offset: 3 }}>
				<div className="login-logo">
					<img src="login-logo.png" alt="Employee Portal Logo" />
				</div>
				<h1>Log In</h1>
                <div>
                    {/*M02 browser error exists? */
                        browserError ? <AlertPanel type="danger" message="Your browser is not supported. Please use a different browser." /> : []}
					{authentication.message ? <AlertPanel type="danger" message={authentication.message} /> : []}
                    {authentication.error ? <AlertPanel type="danger" message={authentication.error} /> : []}

					{authentication.loggingIn ? <Loading /> : []}
					{!authentication.loggingIn ?
						<form onSubmit={this.handleLogin}>
							<FormGroup controlId="employeeCode" bsSize="large">
								<FormLabel>Employee code</FormLabel>
								<FormControl
									autoFocus
									type="text"
									value={this.state.employeeCode}
									onChange={this.handleChange}
								/>
							</FormGroup>
							<FormGroup controlId="password" bsSize="large">
								<FormLabel>Password</FormLabel>
								<FormControl
									type="password"
									value={this.state.password}
									onChange={this.handleChange}
								/>
							</FormGroup>

							<br />
              <Button
                className="btn btn-default"
								block
								bsSize="large"
								disabled={!this.validateForm() || browserError} /*M02 disable if there's a browser error*/
								type="submit"
							>
								Log In
							</Button>
							<br/>
              <Button
                className="btn btn-default"
								block
								className="secondary"
                                onClick={this.handleForgotPassword}
                                disabled={browserError} /*M02 disable if there's a browser error*/
							>
								Forgotten password
							</Button>

                            {/*M01*/}
              <Button
                className="btn btn-default"
                block
                className="secondary"
                onClick={this.handleForgotPassword} /*M02 disable if there's a browser error*/
                disabled={browserError} /*M02 disable if there's a browser error*/
              >
                First time user
							</Button>

						</form>
					: []}
				</div>
			</Col>
		);
	}
}

export default connect(
	state => ({ authentication: state.authentication, alerts: state.alerts.alerts }),
	dispatch => bindActionCreators(userActions, dispatch)
)(Login);